"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoCorrectReplaceInfo = exports.AutoCorrectSettings = void 0;
var list_1 = require("@devexpress/utils/lib/utils/list");
var AutoCorrectSettings = (function () {
    function AutoCorrectSettings() {
        this.detectUrls = true;
        this.correctTwoInitialCapitals = false;
        this.replaceTextAsYouType = false;
        this.enableAutomaticNumbering = true;
        this.caseSensitiveReplacement = false;
        this.replaceInfoCollection = [];
    }
    AutoCorrectSettings.prototype.copyFrom = function (obj) {
        this.detectUrls = obj.detectUrls;
        this.correctTwoInitialCapitals = obj.correctTwoInitialCapitals;
        this.replaceTextAsYouType = obj.replaceTextAsYouType;
        this.enableAutomaticNumbering = obj.enableAutomaticNumbering;
        this.caseSensitiveReplacement = obj.caseSensitiveReplacement;
        this.replaceInfoCollection = list_1.ListUtils.map(obj.replaceInfoCollection, function (d) { return new AutoCorrectReplaceInfo(d.replace, d.with); });
    };
    AutoCorrectSettings.prototype.clone = function () {
        var result = new AutoCorrectSettings();
        result.copyFrom(this);
        return result;
    };
    return AutoCorrectSettings;
}());
exports.AutoCorrectSettings = AutoCorrectSettings;
var AutoCorrectReplaceInfo = (function () {
    function AutoCorrectReplaceInfo(whatReplace, withReplace) {
        this.replace = whatReplace;
        this.with = withReplace;
    }
    AutoCorrectReplaceInfo.prototype.clone = function () {
        return new AutoCorrectReplaceInfo(this.replace, this.with);
    };
    return AutoCorrectReplaceInfo;
}());
exports.AutoCorrectReplaceInfo = AutoCorrectReplaceInfo;
